import { Map, List, fromJS } from 'immutable'

export function crud(state = Map(), { type, entity_id, ...vars }) {
  if (!entity_id) return state
  let items, item

  switch (type) {
    // Handle fetching
    case 'CRUD_ITEMS_FETCH_LOADING':
      return state.setIn([entity_id, 'fetchLoading'], vars.loading || false)

    case 'CRUD_ITEMS_FETCH_ERROR':
      return state.setIn([entity_id, 'fetchError'], vars.message || false)

    case 'CRUD_ITEMS_FETCH_SUCCESS':
      return state.setIn([entity_id, 'items'], List.isList(vars.items) ? vars.items : fromJS(vars.items))

    // Handle create
    case 'CRUD_ITEM_CREATE_LOADING':
      return state.setIn([entity_id, 'createLoading'], vars.loading || false)

    case 'CRUD_ITEM_CREATE_ERROR':
      return state.setIn([entity_id, 'createError'], vars.message || false)

    case 'CRUD_ITEM_CREATE_SUCCESS':
      items = state.getIn([entity_id, 'items'], List())
      return state.setIn([entity_id, 'items'], items.push(Map.isMap(vars.item) ? item : fromJS(vars.item)))

    // Handle update
    case 'CRUD_ITEM_UPDATE_LOADING':
      return state.setIn([entity_id, 'updateLoading'], vars.loading || false)

    case 'CRUD_ITEM_UPDATE_ERROR':
      return state.setIn([entity_id, 'updateError'], vars.message || false)

    case 'CRUD_ITEM_UPDATE_SUCCESS':
      item = Map.isMap(vars.item) ? item : fromJS(vars.item)
      items = state.getIn([entity_id, 'items'], List()).map(i => (i.get('id') === vars.item_id ? item : i))

      return state.setIn([entity_id, 'items'], items)

    // Handle delete
    case 'CRUD_ITEM_DELETE_LOADING':
      return state.setIn([entity_id, 'deleteLoading'], vars.loading || false)

    case 'CRUD_ITEM_DELETE_ERROR':
      return state.setIn([entity_id, 'deleteError'], vars.message || false)

    case 'CRUD_ITEM_DELETE_SUCCESS':
      items = state.getIn([entity_id, 'items'], List()).filter(i => (i.get('id') === vars.item_id ? false : true))

      return state.setIn([entity_id, 'items'], items)

    default:
      return state
  }
}
